import request from "@/CommonDP/utils/request";
export default {
    //获取树
    getProgramme(prjId,enterpriseId,programmeName) {
      return request.get(`/bimAdministration/getProgramme?prjId=${prjId}&enterpriseId=${enterpriseId}&programmeName=${programmeName}`);
    },

    addProgramme(params) {
      return request.post(`/bimAdministration/addProgramme`,params);
    },
    updateProgramme(params) {
      return request.post(`/bimAdministration/updateProgramme`,params);
    },

    delProgramme(programmeId) {
      return request.get(`/bimAdministration/delProgramme?programmeId=${programmeId}`);
    },

}